(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[533],{

/***/ 74383:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/newsletter",
      function () {
        return __webpack_require__(14056);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 5205:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Select; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _heroicons_react_solid__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13342);


function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function Select(param) {
    var children = param.children, label = param.label, id = param.id, register = param.register, error = param.error, name = param.name, selected = param.selected, _mainClass = param.mainClass, mainClass = _mainClass === void 0 ? '' : _mainClass, _options = param.options, options = _options === void 0 ? [] : _options, _primary = param.primary, primary = _primary === void 0 ? false : _primary;
    var okLabelColor = primary ? 'text-gray-600' : 'text-primary';
    var labelColor = error ? 'text-red-600' : okLabelColor;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "".concat(mainClass, " relative border border-1 ").concat(primary ? 'bg-white border-gray-100' : 'bg-gray-100 border-gray-400', " group w-full transition-all overflow-hidden"),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("select", _objectSpread({}, register, {
                className: "input-text z-[3] rounded-none relative block w-full px-2 ".concat(label ? 'py-1 pt-5' : 'py-2', " bg-transparent border-b-2 border-0 border-transparent group-hover:border-secondary focus:outline-none focus:border-primary ring-0 ").concat(error ? 'border-red-600s' : ''),
                id: id,
                name: name,
                defaultValue: "",
                children: options.length ? options.map(function(option, index) {
                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                        value: option.value,
                        selected: option.value === selected,
                        children: option.label
                    }, index);
                }) : children
            })),
            label && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                className: "absolute top-1 z-10 block w-9/10 px-2 text-xs font-bold ".concat(labelColor),
                htmlFor: id,
                children: label
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_heroicons_react_solid__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                className: "absolute right-2 top-1/2 -translate-y-1/2 h-5 fill-gray-400"
            })
        ]
    }));
};


/***/ }),

/***/ 16578:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Spinner; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65988);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__);


function Spinner(param) {
    var classNames = param.classNames;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "jsx-89fc7512f88c442c" + " " + "wls-spinner border-primary border-l-transparent border-4 ".concat(classNames)
            }),
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default()), {
                id: "89fc7512f88c442c",
                children: ".wls-spinner.jsx-89fc7512f88c442c{margin:auto;\ndisplay:block;\nborder-radius:50%;\n-webkit-animation:lds-dual-ring 1.2s linear infinite;\nanimation:lds-dual-ring 1.2s linear infinite}\n@keyframes lds-dual-ring {0% {transform:rotate(0deg)}100% {transform:rotate(360deg)}}"
            })
        ]
    }));
};


/***/ }),

/***/ 14056:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Newsletter; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(87536);
/* harmony import */ var _lib_connect__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43424);
/* harmony import */ var _components_elements_input__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66505);
/* harmony import */ var _components_elements_button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(81474);
/* harmony import */ var _components_helper_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34892);
/* harmony import */ var _components_content_headline__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(17587);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67294);
/* harmony import */ var _components_elements_select__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5205);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _components_elements_spinner__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(16578);











function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function Newsletter() {
    var RenderServerErrors = function RenderServerErrors() {
        var errors = [];
        Object.keys(serverErrors).forEach(function(k) {
            serverErrors[k].map(function(e) {
                return errors.push(e);
            });
        });
        return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
            className: "list-disc",
            children: errors.map(function(e, i) {
                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                    className: "ml-4 text-red-800",
                    children: e
                }, i);
            })
        }));
    };
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false), showSuccessMessage = ref[0], setShowSuccessMessage = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(null), serverErrors = ref1[0], setServerErrors = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false), isSending = ref2[0], setIsSending = ref2[1];
    var ref3 = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_10__/* .useForm */ .cI)(), getValues = ref3.getValues, register = ref3.register, handleSubmit = ref3.handleSubmit, errors1 = ref3.formState.errors;
    var onSubmit = function() {
        setServerErrors(null);
        var fields = getValues();
        delete fields.terms;
        Object.keys(fields).forEach(function(key) {
            if (fields[key] === '') {
                delete fields[key];
            }
        });
        setIsSending(true);
        if (fields.birthday && moment__WEBPACK_IMPORTED_MODULE_8___default()(fields.birthday, (moment__WEBPACK_IMPORTED_MODULE_8___default().ISO_8601)).isValid()) {
            fields.birthday = moment__WEBPACK_IMPORTED_MODULE_8___default()(fields.birthday, (moment__WEBPACK_IMPORTED_MODULE_8___default().ISO_8601)).format('DD.MM.Y');
        }
        (0,_lib_connect__WEBPACK_IMPORTED_MODULE_1__/* .fetchAPIPost */ .u9)('/newsletter', fields).then(function() {
            setIsSending(false);
            setShowSuccessMessage(true);
        }).catch(function(json) {
            setIsSending(false);
            setServerErrors(json.errors);
        });
    };
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        className: "max-w-7xl mx-auto w-full px-6 xl:px-0 mt-24",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_content_headline__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                before: "Newsletter",
                children: "abonnieren"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                children: "Abonnieren Sie unseren Newsletter, um keine unserer besten Angebote, neuesten Nachrichten, Artikel und vieles mehr zu verpassen."
            }),
            showSuccessMessage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "mt-2 p-3 bg-primary text-white",
                children: "Sie haben sich erfolgreich f\xfcr unseren Newsletter angemeldet. Danke f\xfcr die Registrierung."
            }),
            serverErrors !== null && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "border-red-800 border p-2 mt-5",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        children: "Leider sind beim Speichern folgende Fehler aufgetreten"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RenderServerErrors, {})
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "relative",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("form", {
                        className: "max-w-7xl m-auto pt-5 grid md:grid-cols-2 gap-5 ".concat(isSending ? 'opacity-50' : '', " ").concat(showSuccessMessage ? 'hidden' : ''),
                        onSubmit: handleSubmit(onSubmit),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_elements_select__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                label: "Anrede",
                                id: "salutation",
                                name: "salutation",
                                register: _objectSpread({}, register('salutation', {
                                    required: true
                                })),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                        value: "",
                                        disabled: true,
                                        hidden: true,
                                        className: "text-gray-500",
                                        children: "Bitte w\xe4hlen"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                        value: "Frau",
                                        children: "Frau"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                        value: "Herr",
                                        children: "Herr"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_elements_select__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                label: "Titel",
                                id: "title",
                                name: "title",
                                register: _objectSpread({}, register('title', {
                                    required: false
                                })),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                        value: "",
                                        hidden: true,
                                        className: "text-gray-500",
                                        children: "-"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                        value: "Dr.",
                                        children: "Dr."
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                        value: "Prof.",
                                        children: "Prof."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_elements_input__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                type: "text",
                                label: "Vorname *",
                                placeholder: "Vorname",
                                name: "firstname",
                                error: errors1 === null || errors1 === void 0 ? void 0 : errors1.firstname,
                                register: _objectSpread({}, register('firstname', {
                                    required: true,
                                    maxLength: 80
                                }))
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_elements_input__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                type: "text",
                                label: "Nachname *",
                                placeholder: "Nachname",
                                name: "lastname",
                                error: errors1 === null || errors1 === void 0 ? void 0 : errors1.lastname,
                                register: _objectSpread({}, register('lastname', {
                                    required: true,
                                    maxLength: 100
                                }))
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_elements_input__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                type: "text",
                                label: "Email *",
                                placeholder: "Email",
                                name: "email",
                                error: errors1 === null || errors1 === void 0 ? void 0 : errors1.email,
                                register: _objectSpread({}, register('email', {
                                    required: true,
                                    pattern: /^\S+@\S+$/i
                                }))
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_elements_input__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                type: "tel",
                                label: "Handynummer",
                                placeholder: "Handynummer",
                                name: "mobile",
                                error: errors1 === null || errors1 === void 0 ? void 0 : errors1.mobile,
                                register: _objectSpread({}, register('mobile', {
                                    required: false,
                                    minLength: 6,
                                    maxLength: 15
                                }))
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_elements_input__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                type: "date",
                                label: "Geburtsdatum",
                                name: "birthday",
                                register: _objectSpread({}, register('birthday', {
                                    required: false
                                }))
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex items-center",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", _objectSpread({
                                        type: "checkbox",
                                        id: "newsletter-agb",
                                        placeholder: "agb",
                                        name: "terms"
                                    }, register('terms', {
                                        required: true
                                    }))),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                        htmlFor: "newsletter-agb",
                                        className: "ml-2 text-sm md:text-base ".concat((errors1 === null || errors1 === void 0 ? void 0 : errors1.terms) ? 'text-red-600' : ''),
                                        children: [
                                            "Ich stimme den",
                                            ' ',
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_helper_link__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                href: "/datenschutz",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                    className: "text-primary",
                                                    children: "Datenschutzbedingungen"
                                                })
                                            }),
                                            ' ',
                                            "zu *"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "text-sm",
                                children: "Mit * gekennzeichnete Felder sind Pflichtfelder"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_elements_button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                type: "submit",
                                children: "abonnieren"
                            })
                        ]
                    }),
                    isSending && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_elements_spinner__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                        classNames: "h-10 w-10 absolute left-[48%] top-[40%]"
                    })
                ]
            })
        ]
    }));
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(74383); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);